import { formatCurrency } from '@angular/common';

export class Numbers {
  public static roundToHundredth(value: number, roundingStrategy: RoundingStrategy = RoundingStrategy.RoundToNearest): number {
    switch (roundingStrategy) {
      case RoundingStrategy.RoundDown:
        return Math.floor(100 * value) / 100;
      case RoundingStrategy.RoundToNearest:
        return Math.round(100 * value) / 100;
      case RoundingStrategy.RoundUp:
        return Math.ceil(100 * value) / 100;
    }
    throw new Error(`Unrecognized rounding strategy: ${roundingStrategy}`);
  }

  public static convertFromDollarsToNumber(value: string): number {
    value = value.replace('$', '');
    value = value.replace(new RegExp(/,/g), '');
    const result = Number.parseFloat(value);
    return isNaN(result) ? null : result;
  }

  public static convertFromDollarsToString(value: string): string {
    value = value.replace('$', '');
    value = value.replace(new RegExp(/,/g), '');
    return value;
  }

  public static convertFromPercentToNumber(value: string): number {
    value = value.replace('%', '');
    value = value.replace(new RegExp(/,/g), '');
    const result = Number.parseFloat(value);
    return isNaN(result) ? null : result;
  }

  public static convertFromPercentToString(value: string): string {
    value = value.replace('%', '');
    value = value.replace(new RegExp(/,/g), '');
    return value;
  }

  public static formatCurrency(value: number): string {
    return formatCurrency(value, 'en-US', '$', 'USD');
  }

  public static minutesToMs(minutes: number): number {
    return minutes * 60 * 1000;
  }
}

export enum RoundingStrategy {
  RoundDown,
  RoundToNearest,
  RoundUp,
}
